import request from '@/utils/request'

//Login
export function loadUPP_summary(params) {
  return request({ url: 'vupp', method: 'post', data: params })
} 
